<template>
  <div class="popup z-index-10-fg confirmation small-popup add-interaction-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Report Filters</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div class="popup-body">
        <MultiDropdown :options="sortedColumnsList" label="Columns" :showSelectAll="true" v-model="filters.columns" class="input-item" />
        <MultiDropdown
          :options="salespeople.map((salesperson) => ({ key: salesperson.USERID, value: salesperson.DISPLAYNAME }))"
          label="Inside Salespeople"
          :showSelectAll="true"
          v-model="filters.insideSalespeople"
          class="input-item" />
        <MultiDropdown
          :options="outsideSalespeople.map((salesperson) => ({ key: salesperson.USERID, value: salesperson.DISPLAYNAME }))"
          label="Outside Salespeople"
          :showSelectAll="true"
          v-model="filters.outsideSalespeople"
          class="input-item" />
        <MultiDropdown :options="pickLists.customerDetail.items.map((item) => item.NAME)" label="Customer Details" :showSelectAll="true" v-model="filters.customerDetails" class="input-item" />
        <MultiDropdown :options="stateList" label="States" :showSelectAll="true" v-model="filters.states" class="input-item small-item" />
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.diaryNotesDateFrom" />
          <label>Only show diary notes from</label>
        </div>
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.diaryNotesDateTo" />
          <label>To</label>
        </div>
        <Checkbox label="Certified Contractors Only" v-model="filters.certifiedContractorsOnly" class="input-item large-item" />
        <Checkbox label="Sales Contacts Only" v-model="filters.salesContactsOnly" class="input-item large-item" />
      </div>
      <div class="popup-footer">
        <button @click="resetFilters" class="text-btn">reset filters</button>
        <button @click="$emit('closePopup')" class="text-btn">close</button>
        <button :class="{ 'square-btn': true, saving: loading }" @click="saveAndRun" :disabled="loading">save & run <img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import MultiDropdown from './inputs/MultiDropdown.vue';
import Checkbox from './inputs/Checkbox.vue';
import useCustomerReportQuery from '@/composables/useCustomerReportQuery';
import useUsersQuery from '@/composables/useUsersQuery';
import usePicklistItemsQuery from '@/composables/usePicklistItemsQuery';

export default {
  name: 'CustomerReportFilter',
  emits: ['closePopup'],
  components: {
    MultiDropdown,
    Checkbox,
  },
  setup() {
    const { filters, columnsList, runReport, stateList, loading, validateFilters, resetFilters } = useCustomerReportQuery();
    const { salespeople, outsideSalespeople } = useUsersQuery();
    const { pickLists } = usePicklistItemsQuery;

    return {
      filters,
      columnsList,
      runReport,
      salespeople,
      outsideSalespeople,
      pickLists,
      stateList,
      loading,
      validateFilters,
      resetFilters,
    };
  },
  computed: {
    sortedColumnsList() {
      return this.columnsList.sort((a, b) => a.order - b.order).map((item) => ({ key: item.name, value: item.title }));
    },
  },
  methods: {
    saveAndRun() {
      if (!this.validateFilters()) return;

      this.$emit('closePopup');
      this.runReport();
    },
  },
};
</script>

<style lang="scss" scoped>
.add-interaction-popup {
  width: 35rem;
  max-height: 85vh;
  overflow-y: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .popup-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;

    .input-item {
      min-width: 10rem;
      flex: 1 0 45%;

      &.small-item {
        min-width: 5rem;
        flex: 1 0 30%;
      }

      &.large-item {
        min-width: 15rem;
        flex: 1 0 75%;
      }
    }
  }
}
</style>
